import { useSuspenseQuery, UseSuspenseQueryResult } from '@tanstack/react-query';
import { paths } from '@/generated/supplier-experience-api';
import apiClient from '@/lib/apiClient';

export type Dismissible =
  paths['/user/dismissibles']['get']['responses']['200']['content']['application/json']['data'][number];
type DismissiblesResponse = paths['/user/dismissibles']['get']['responses']['200']['content']['application/json'];

const fetchDismissibles = async (): Promise<Dismissible[]> => {
  const dismissiblesResponse = await apiClient
    .get('api/supplier-experience/user/dismissibles')
    .json<DismissiblesResponse>();
  return dismissiblesResponse.data ?? [];
};

const useDismissibles = ({ enabled = true }: { enabled?: boolean }): UseSuspenseQueryResult<Dismissible[]> => {
  return useSuspenseQuery<Dismissible[], Error>({
    queryKey: ['dismissibles'],
    queryFn: () => (enabled ? fetchDismissibles() : []),
  });
};

export default useDismissibles;
